<template>
  <div class="stake-n-return">
    <div class="stake-line"  >
      <span class="stake">
        <!--<span class="currency">$</span>-->
        <money-input v-model="betTypeStakes[id]"
                     :id="1"
                     :inputType="'stake'"
                     :placeholder="placeholder.wager"
                     :disabled="currentBetSlipState>=1"
                     :focus="focus"
                     :perType="perType"
                     :minStake="minStake[perType]"
                     :maxStake="maxStake[perType]"
                     @dismissError="dismissError"
                     @setFocus="setFocus"
                     @hasError="hasError"
                     @input="storeInput"
                     :stakeChanged="inRefferalStakeChanged"
                     :stakeChange="stakeChange"
        >
        </money-input>
      </span>
      <!--<span class="label-returns">{{ $t('BetSlip.single.returns') }}</span>-->
      <span class="returns">
        <!--<span class="currency">$</span>-->
        <money-input v-model="winning"
                     :id="2"
                     :inputType="'winning'"
                     :placeholder="placeholder.return"
                     :disabled="currentBetSlipState>=1"
                     :focus="focus"
                     :perType="perType"
                     :minStake="minStake[perType]"
                     :maxStake="maxStake[perType]"
                     @dismissError="dismissError"
                     @setFocus="setFocus"
                     @hasError="hasError"
                     @input="storeInput"
        >
        </money-input>
      </span>
    </div>
    <div v-if="hasErrors" class="error-msg">
      <div v-for="e in errors">
        <span v-if="e">{{ $t('BetSlip.stakeNreturn.error.' + e, {min:minStake[perType], max:maxStake[perType]}) }}</span>
      </div>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import moneyInput from './moneyInput.vue'
  import priceFormat from '@/library/priceFormat'
  import Icon from '@/components/common/Icon'
//  import config from '@/config'
//  import priceFormat from '@/library/priceFormat'

  export default {
    props: ['id', 'perType', 'sport', 'inRefferalStakeChanged', 'stakeChange'],

    components: {
      moneyInput,
      Icon
    },

    data () {
      return {
        preventGet: false,
        focus: [0],
        errors: {}
      }
    },

    computed: {
      minStake () {
        return store.getters['sbBetslipState/minStake']
      },
      maxStake () {
        return store.getters['sbBetslipState/maxStake']
      },
      currentBetSlipState () {
        return store.getters['sbBetslipState/currentBetSlipState']
      },
      allowedBetTypesAndReturns () {
        return store.getters['sbBetslipState/allowedBetTypesAndReturns']
      },
      allowedBetTypesAndReturn () {
        if (this.tab === 'TEASER') {
          return this.allowedBetTypesAndReturns &&
            this.allowedBetTypesAndReturns[this.tab] &&
            this.allowedBetTypesAndReturns[this.tab][this.sport] &&
            this.allowedBetTypesAndReturns[this.tab][this.sport].PotentialReturns &&
            this.allowedBetTypesAndReturns[this.tab][this.sport].PotentialReturns[this.perType] &&
            this.allowedBetTypesAndReturns[this.tab][this.sport].PotentialReturns[this.perType][this.id]
        }
        return this.allowedBetTypesAndReturns &&
          this.allowedBetTypesAndReturns[this.tab] &&
          this.allowedBetTypesAndReturns[this.tab].PotentialReturns &&
          this.allowedBetTypesAndReturns[this.tab].PotentialReturns[this.perType] &&
          this.allowedBetTypesAndReturns[this.tab].PotentialReturns[this.perType][this.id]
      },
      tab () {
        return store.getters['sbBetslipState/tab']
      },
      betTypeStakesAll () {
        return store.getters['sbBetslipState/betTypeStakes']
      },
      winnings () {
        return store.getters['sbBetslipState/returns']
      },
      placeholder () {
        return {
          // wager: this.$gettext('BetSlip.input.placeholder.wager'),
          // return: this.$gettext('BetSlip.input.placeholder.return')
          wager: this.$t('BetSlip.input.placeholder.wager'),
          return: this.$t('BetSlip.input.placeholder.return')
        }
      },
      odds () {
        return this.allowedBetTypesAndReturn &&
          this.allowedBetTypesAndReturn.PotentialReturn &&
          this.allowedBetTypesAndReturn.PotentialReturn * 1
      },
      betTypeStakes () {
//        return this.stakes[this.id]
        var betTypeStakes = {}
        if (this.tab === 'TEASER') {
          betTypeStakes = this.betTypeStakesAll &&
            this.betTypeStakesAll[this.tab] &&
            this.betTypeStakesAll[this.tab][this.sport] &&
            this.betTypeStakesAll[this.tab][this.sport][this.perType]
        } else {
          betTypeStakes = this.betTypeStakesAll && this.betTypeStakesAll[this.tab] && this.betTypeStakesAll[this.tab][this.perType]
        }
        return betTypeStakes || {}
      },

      winning: {
        get: function () {
//          console.log('winning get')
          var stake = parseFloat(this.betTypeStakes[this.id])
          var unitCount = this.allowedBetTypesAndReturn && this.allowedBetTypesAndReturn.UnitCount
//          console.log('stake: ' + stake)
          var win = ''
          if (!this.preventGet && this.hasValue(stake) && unitCount) {
            win = this.odds * stake - unitCount * stake
//            win = parseFloat(win.toFixed(2))
          } else {
            win = this.preventGet ? this.preventGet : ''
            this.preventGet = false
          }
          this.commitWinToStore(win)
//          console.log('get win: ' + win)
          return win
        },
        set: function (v) {
//          console.log('set win: ' + v)
          if (v && v < 0) {
            v = ''
          }
          this.preventGet = v
          var unitCount = this.allowedBetTypesAndReturn && this.allowedBetTypesAndReturn.UnitCount
          var s = ''
          if (unitCount) {
            s = v / (this.odds - this.allowedBetTypesAndReturn.UnitCount)
          }
//          s = parseFloat(s.toFixed(2))
//          this.betTypeStakes[this.id] = v ? s : ''
          Vue.set(this.betTypeStakes, this.id, v ? s : '')
        }
      },

      hasErrors () {
        return this.errors.stake || this.errors.winning
      }
    },

    methods: {
      hasValue (v) {
        return v || parseFloat(v) >= 0
      },
      storeInput (val) {
//        console.log('storeInput: ' + val)
      },
      hasError (val) {
//        this.errors[val[0]] = val[1]
        Vue.set(this.errors, val[0], val[1])
      },
      commitWinToStore (win) {
//        console.log('commit win: ' + win)
//        this.winnings[this.tab][this.perType][this.id] = win
        if (this.id && this.perType) {
          if (this.tab === 'TEASER') {
            if (this.sport) {
              Vue.set(this.winnings[this.tab][this.sport][this.perType], this.id, win)
            }
          } else {
            Vue.set(this.winnings[this.tab][this.perType], this.id, win)
          }
        }
      },
      dismissError (id, hasError) {
//        this.$emit('dismissError', id, val)
//        if (hasError) {
        store.commit('sbBetslipState/dismissErrorFromSelection', hasError)
//        }
      },
      setFocus (id, val) {
//        this.focus[id] = val
        if (val) {
          Vue.set(this.focus, 0, id)
        } else {
          if (this.focus[0] === id) {
            Vue.set(this.focus, 0, 0)
          }
        }
      },
      killFocus (id) {
        this.focus[id] = !true
      },
      formatPrice (v) {
        return priceFormat.formatOdds(v, 0)
      }
    },

    created () {

    },

    watch: {
      odds (v) {
        if (v) {
//          console.log('watch odds (Stake-N-Return): ' + v)
          var stake = this.betTypeStakes && this.betTypeStakes[this.id] && this.betTypeStakes[this.id] * 1
          var unitCount = this.allowedBetTypesAndReturn && this.allowedBetTypesAndReturn.UnitCount && this.allowedBetTypesAndReturn.UnitCount * 1
          var win = v * stake - unitCount * stake
//          console.log('watch odds win: ' + win)
          if (win) {
//            win = this.roundToUnit(win, true)
            win = parseFloat(win.toFixed(2))
//            console.log('watch odds win2: ' + win)
            this.winning = win
//            Vue.set(this, 'winning', win)
            this.commitWinToStore(win)
//            this.betTypeStakes[this.id] = stake
            Vue.set(this.betTypeStakes, this.id, stake)
          }
        }
      }
    },

    destroyed () {
    }
  }
</script>

<style lang="stylus" scoped>
@import "~@/css/config"
  .stake-line {
    color: #06283b;
    display: flex;
    > span {
      text-align: center;
      margin-right: 8px;
      flex: 1;

      &:last-child {
        margin-right: 0;
      }
      /*padding: 3px;*/
    }
    span.label-returns {
      width: 23%;
    }
  }

  .priceUp {
    .selection-price {
      background-color: green;
      color: white;
    }
  }

  .priceDown {
    .selection-price {
      background-color: red;
      color: white;
    }
  }
  .review > span {
    display: inline-block;
    width: 32%;
    text-align: center;
  }


  .SBbetSlip {
    .error-msg {
      /*display: none;*/
    }
  }

  .error-msg
    display: flex
    padding: 10px
    margin: 7px 0px 0
    background-color: rgba(228, 66, 66, 0.1)
    color: #DB3F3F
    font-weight: normal
    text-transform: uppercase
    text-align: left
    font-size: 12px
    line-height: 14px
    align-items: center
    justify-content: left

  .inRefferalStakeChanged
    padding: 10px
    margin: 7px 0px 0
    border-style: solid
    color: #EA913C
    border-color: #EA913C
    border-width: 1px !important
    background-color: #FFF2E5
    border-radius: 3px
    font-size: 12px
    font-weight: bold

</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/stakeNreturn.vue